import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, Button ,  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper, FormControl,InputLabel, Select , MenuItem} from '@mui/material';
import { makeStyles } from '@mui/styles';
import JobService from "../../services/console_services/Jobs";
import Divider, { dividerClasses } from '@mui/material/Divider';
import ModuleRunStatusByNetwork from '../moduleRunStatus/index';
import { useMsal } from '@azure/msal-react';
import CircularProgress from '@mui/material/CircularProgress';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2.5, 2.5, 1.25, 10),
    fontFamily: theme.fontFamily,
    fontSize: "16px"
  },
  container: {
    display: "block",
    padding: "20px 30px",
    background: "#fff",
    boxShadow: "0 0 6px #eee",
    borderRadius: "6px",
  },

  title: {
    marginBottom: "20px"
  },
  runs: {
    display: "flex",
    width: "max-content",
    rowGap: "20px",
    marginTop: "10px",
    marginBottom: "20px",
    boxShadow: "0 0 6px rgba(255, 194, 26,.5)",
    borderRadius: "6px",
    backgroundColor: '#fff',
  },
  runItem: {
    display: 'flex',
    flexDirection: "column",

    padding: "20px",
    borderRight: "2px solid #eee",
    ['&:first-child']: {

    },
    ['&:last-child']: {
      borderRight: "0px",
    }
  },
  moduleName: {
    fontSize: '12px',
    fontWeight: 700,
    color: "#333333",
    marginBottom: "8px",
  },
  moduleNameLight: {
    fontSize: '12px',
  },
  time: {
    fontSize: "12px",
    marginBottom: "8px",
    color: "#59595A",
  },
  button: {
    fontSize: "10px",
    border: "none",
    borderRadius: "10px",
    padding: "5px 10px",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    marginBottom: "20px",
    columnGap: "30px"
  },
  footer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  icon: {
    padding: "8px 0 0 0", cursor: "pointer", fontSize: "18px"
  },
  dotStart: {
    color: "#84ce00",
    marginRight: "4px"
  },
  dotEnd: {
    color: "#FF00FF",
    marginRight: "4px"
  },
  container2: {
    display: "flex",
    width: '100%',
    padding: "20px 10px",
    background: "#fff",
    boxShadow: "0 0 10px #ddd",
    borderRadius: "6px",
    marginBottom: '20px',
  },
  tiles: {
    display: 'flex',
    flexDirection: "column",
    padding: "10px 30px",
    borderRight: "2px solid #eee",
    ['&:first-child']: {

    },
    ['&:last-child']: {
      borderRight: "0px",
    }
  },
  counts: {
    color: "#0067a1",
    fontSize: "32px",
    fontWeight: "600",
    marginRight:"10px",
    marginBottom: "12px",
    textAlign: "left",
    margin: 0
  },
  labels: {
    color: "#929497",
    textAlign: "left",
    margin: 0
  },
  perc:{
    color: "#aaa",
    
  }
}));

const Statuses = [{
  code: "TOTAL",
  count: 0,
  label: "Total Number of Modules",
  per:null
}, {
  code: "SUCCESS",
  count: 0,
  label: "Successful Executions",
  per:null
}, {
  code: "RUNNING",
  count: 0,
  label: "Modules Currently Running",
  per:null
}, {
  code: "FAILED",
  count: 0,
  label: "Failed Executions",
  per:null
}];

const ModuleRunStatus = () => {
  // const classes = useStyles();
  const { instance } = useMsal();
  const [items, setItems] = useState([]);
  const [totals, setTotals] = useState(0);
  const [counts, setCounts] = useState(Statuses);
  // const [jobsByNetwork, setJobsByNetwork] = useState(false);
  const [loading, setLoading] = useState(true);
  const [data, setData]= useState([]);
  const [statusType, setStatusType] = useState('weekly');

  const fetchJobRuns = async () => {

    try {
      const response = await JobService.getJobs();
      if (response?.data) {
        setItems(response?.data || []);
      }
    } catch (error) {
      console.error('fetchJobRuns', error);
    } finally {
      console.log(items);
    }
  };
  useEffect(() => {
    fetchJobRuns();
  }, []);

  useEffect(() => {
    setTotals(items.reduce((p, i) => p + i?.runs?.length, 0));
    setCounts(counts.map((i) => {
      if (i.code === "TOTAL") {
        i.count = totals;
      } else if (i.code === "SUCCESS") {
        i.count = items.reduce((p, i) => p + i?.runs?.filter((i) => i.result === 'SUCCESS')?.length, 0);
        if(i.count && totals){
          i.per = `(${(i.count * 100 / totals).toFixed(2)}%)`;
        }
      } else if (i.code === "RUNNING") {
        i.count = items.reduce((p, i) => p + i?.runs?.filter((i) => i.status === 'RUNNING')?.length, 0);
        if(i.count && totals){
          i.per = `(${(i.count * 100 / totals).toFixed(2)}%)`;
        }
      } else if (i.code === "FAILED") {
        i.count = items.reduce((p, i) => p + i?.runs?.filter((i) => i.result !== 'SUCCESS')?.length, 0);
        if(i.count && totals){
          i.per = `(${(i.count * 100 / totals).toFixed(2)}%)`;
        }
      }
      return i;
    }));
  }, [items, totals]);

  // const handleRedirect = (item) => {
  //   window.open(item?.run_page_url, '_blank');
  // }

  // function getColor(item) {
  //   if (item.status === "RUNNING") {
  //     return "#FCF2CF"
  //   } else if (item.result === "SUCCESS") {
  //     return "#ACECBE"
  //   }
  //   return "#f9a3a3";
  // }

  // function getLabel(item) {
  //   if (item.status === "RUNNING") {
  //     return "RUNNING"
  //   }
  //   return item.result;
  // }
  // const handleJobsByNetwork = () => {
  //   setJobsByNetwork(true);
  // }
  // console.log("jobsByNetwork", jobsByNetwork);
  const fetchJobRunsStatus = async () => {
      const params = {
       type: statusType
      };
      try {
        const response = await JobService.getjobStatusreport  (params, instance);
        console.log("res>>>>>>>>>>>>>", response);
        if (response) {
          setLoading(false);
          setData(response || []);
        }
      } catch (error) {
        console.error('fetchJobRuns', error);
      } 
    };
  
    useEffect(() => {
      fetchJobRunsStatus();
    }, [statusType]);
  const columns = [
  { id: "runToReport", label: "Run to Report" },
  { id: "ambient", label: "Ambient" },
  { id: "chilled", label: "Chilled" },
  { id: "frozen", label: "Frozen" },
  { id: "npw", label: "NPW" },
  { id: "ups", label: "UPS"},
  // { id: "all", label: "All" },
  { id: "totalRuns", label: "Total Runs" },
  { id: "successfulRuns", label: "Successful Runs" },
  { id: "successfulRunPercent", label: "Successful Run %" },
  // { id: "successfulReportPercent", label: "Successful Report %" },
  { id: "weeklyRuns", label: "Run Type" },
  // {id: "dateRange", label: "Date Range"},
  
];
//   const rows = [
//   {
//     runToReport: "Capacity Planning",
//     ambient: "5.0",
//     chilled: "5.0",
//     frozen: "5.0",
//     npw: "5.0",
//     successfulRuns: "5",
//     totalRuns: "5",
//     successfulRunPercent: "100%",
//     successfulReportPercent: "100%",
//     weeklyRuns: "Daily"
//   },
//   {
//     runToReport: "Deployment Optimization",
//     ambient: "4.0",
//     chilled: "4.0",
//     frozen: "4.0",
//     npw: "4.0",
//     successfulRuns: "4",
//     totalRuns: "4",
//     successfulRunPercent: "100%",
//     successfulReportPercent: "100%",
//     weeklyRuns: "Daily/4days"
//   }
//   // Add more rows as needed
// ];

const handleStatusTypeChange = (event) => {
    setStatusType(event.target.value);
    setLoading(true);
  };
  return (
    <>
     <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 , mr:5, mt:2}}>
    <FormControl sx={{ minWidth: 150 }}>
  <InputLabel id="demo-simple-select-label">Duration</InputLabel>
  <Select
    labelId="demo-simple-select-label"
    id="demo-simple-select"
    value={statusType}
    label="weekly"
    onChange={handleStatusTypeChange}
  >
    <MenuItem value={"daily"}>daily</MenuItem>
    <MenuItem value={"weekly"}>weekly</MenuItem>
    <MenuItem value={"monthly"}>monthly</MenuItem>
  </Select> 
  </FormControl>
  </Box>
  {loading ? (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
    <CircularProgress />
  </Box>
) : (
  <Box sx={{ ml: 3, mr: 2 }}>
    <Box>
      <Typography variant="h6" sx={{ml:8}}>
       {`Date Range - ${data[0].dateRange}`}
      </Typography>
    </Box>
    <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {columns.map((col, colIndex) => (
              <TableCell
                key={`header-${colIndex}-${col.id}`}
                sx={{
                  backgroundColor: "#F58220",
                  color: "#fff",
                  fontWeight: "bold",
                  textAlign: "center"
                }}
              >
                {col.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        {/* <TableBody>
  {data.length > 0 ? (
    data.map((row, rowIndex) => (
      <TableRow key={`row-${rowIndex}`}>
        {columns.map((col, colIndex) => (
          <TableCell key={`cell-${rowIndex}-${col.id}`} sx={{ textAlign: "center" }}>
            {row[col.id]}
          </TableCell>
        ))}
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={columns.length} sx={{ textAlign: "center" }}>
        No data available for {statusType}
      </TableCell>
    </TableRow>
  )}
</TableBody> */}
<TableBody>
  {data.length > 0 ? (
    data.map((row, rowIndex) => (
      <TableRow key={`row-${rowIndex}`}>
        {columns.map((col, _colIndex) => {
          let cellValue = row[col.id];
          let cellStyle = { textAlign: "center" };

          // Apply color only for successfulReportPercent
          if (col.id === "successfulReportPercent" || col.id === "successfulRunPercent") {
            const percent = parseInt(cellValue, 10); // remove '%' and convert to number
            if (percent >= 80) {
              cellStyle.color = "green";
            } else if (percent >= 50) {
              cellStyle.color = "orange";
            } else {
              cellStyle.color = "red";
            }
          }

          return (
            <TableCell key={`cell-${rowIndex}-${col.id}`} sx={cellStyle}>
              {cellValue}
            </TableCell>
          );
        })}
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={columns.length} sx={{ textAlign: "center" }}>
        No data available for {statusType}
      </TableCell>
    </TableRow>
  )}
</TableBody>
      </Table>
    </TableContainer>
  </Box>
)}
 
{/*     
      {jobsByNetwork ? ( <ModuleRunStatusByNetwork key="networkView"/>


) :
     ( <div className={classes.root}>
        <div className={classes.container}>
          <div className={classes.header}>
            <div className={classes.time}>
              <i className={classes.dotStart}>●</i>Last Run start
            </div>

            <div className={classes.time}>
              <i className={classes.dotEnd}>●</i>Last Run Complete
            </div>
            <div>
              <Button variant="outlined" onClick={handleJobsByNetwork} style={{ marginLeft: 'auto' }}> Jobs By Network</Button>
            </div>
          </div>


          <div className={classes.container2}>
            {counts.map((item, i) => (
              <div key={i} className={classes.tiles}>
                <p><span className={classes.counts}>{item.count}</span><span className={classes.perc}>{item.per || ''}</span></p>
                <p className={classes.labels}>{item.label}</p>
              </div>
            ))}
          </div>


          {items.map((item) => (
            <>
              <Typography className={classes.title}>{'→'} {item.module}</Typography>
              <div className={classes.runs}>
                <>
                  {item?.runs?.length > 0 && item.runs.map((run) => (
                    <>
                      <div className={classes.runItem}>
                        <div className={classes.moduleName}>
                          {run.run_name || item.module}
                        </div>

                        <div className={classes.time}>
                          <i className={classes.dotStart}>●</i>{run.start_time || 'N/A'}
                        </div>

                        <div className={classes.time}>
                          <i className={classes.dotEnd}>●</i>{run.end_time || 'N/A'}
                        </div>

                        <div className={classes.footer}>
                          <div>
                            <button className={classes.button} style={{
                              backgroundColor: getColor(run)
                            }}>
                              {getLabel(run)}
                            </button>
                          </div>
                          <div className={classes.icon} onClick={() => handleRedirect(run)}>
                            <IconNotebook />
                          </div>
                        </div>
                      </div>
                    </>
                  ))}

                  {item?.runs?.length == 0 && (<div className={classes.runItem}>
                    <div className={classes.moduleNameLight}>
                      N/A
                    </div>
                  </div>)}
                </>
              </div>
            </>
          ))}
        </div>
      </div>)
      } */}
    </>
  );
};

function IconNotebook(props) {
  return (
    <svg
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      viewBox="0 0 24 24"
      height="1em"
      width="1em"
      {...props}
    >
      <path stroke="none" d="M0 0h24v24H0z" />
      <path d="M6 4h11a2 2 0 012 2v12a2 2 0 01-2 2H6a1 1 0 01-1-1V5a1 1 0 011-1m3 0v18M13 8h2M13 12h2" />
    </svg>
  );
}


export default ModuleRunStatus;
